export { Paginator, Paginator as default } from './Paginator'

export { PaginatorControlsSkeleton } from './Paginator.styled'
